import React, { CSSProperties } from 'react';
import { KeyboardAvoidingView, StyleSheet, StyleProp, ViewStyle, Text, PixelRatio, View, TextStyle } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import useFontSize from '../shell/hooks/useFontSize';
import { isMobile } from '../shell/utils/platformCheck';
import { useAppSelector } from '../store/hooks';
import { selectTtalk, TtalkStateINT } from '../store/slices/gameObjectSlice';
import TTextInput from './TTextInput';


interface TTalkContainerProps {
    style?: StyleProp<ViewStyle>;
    textStyle?: StyleProp<TextStyle>;
    talkStyle?: StyleProp<ViewStyle>;
    talkObject?: TtalkStateINT,
    numberOfLines?: number,
    padding?: number,
}

const TTalkContainer: React.FC<TTalkContainerProps> = ({ style, talkObject, textStyle, numberOfLines, padding, talkStyle }) => {
    const talkSlice = talkObject ? talkObject : useAppSelector(selectTtalk);

    const styles = StyleSheet.create({
        _talkStyle: {
            flex: 2.3,
            // flexBasis: (width / 1.5),
            // alignSelf: "center",
            paddingLeft: "12%",
            // bottom: isMobile() ? 100 / PixelRatio.get() : height / 9,
            alignSelf: "flex-start"
        },
        text: {
            padding: 5,
            color: "white",
            fontSize: useFontSize(2.6),
            textAlign: "left",
            // fontWeight: "bold",
            textShadowColor: 'rgba(0, 0, 0, 1)',
            textShadowOffset: { width: 0, height: 0 },
            fontStyle: talkSlice.options?.think ? "italic" : "normal",
            fontFamily: isMobile() ? '' : "cursive",
            // ugly fix until the resetting shadow issue is solved
            textShadowRadius: (textStyle as any)?.[0]?.textShadowRadius != null ? (textStyle as any)?.[0].textShadowRadius : 5,
        }, charName: {

            fontSize: useFontSize(2.9),
            textShadowColor: 'rgba(0, 0, 0, 0.5)',
            color: talkSlice.character?.color || "whitesmoke",
            textShadowRadius: 1,
            fontWeight: "bold",
            textShadowOffset: { width: 1, height: 1 },

        }, method: {
            position: "relative",
            color: "whitesmoke",
            // fontStyle: "italic",
            left: 15 / PixelRatio.get(),
            top: 2 / PixelRatio.get(),
            fontSize: useFontSize(0.9)
        },

    });
    // TODO: add dynamic colors 
    // /(\|color\|=)[']+/g.test("fdsf|color|='red' ddd")
    return (
        <>

            <KeyboardAvoidingView style={[styles._talkStyle, style, talkStyle]} >
                {
                    talkSlice.hide ? <></> :
                        <>
                            {talkObject?.character?.name != '' ? <Text selectable={false} numberOfLines={3} adjustsFontSizeToFit style={[styles.text, styles.charName, { opacity: !talkSlice.options?.think && talkObject?.character?.name != '' ? 1 : 0 }]} >
                                {talkSlice.character?.name}
                                {talkSlice.options?.method && talkSlice.text ? <Text style={styles.method}>[{talkSlice.options?.method}] </Text> : <></>}
                            </Text> : <></>}
                            <View style={[{ padding }]}>
                                {!textStyle ? <Text selectable={false} numberOfLines={numberOfLines || 3} adjustsFontSizeToFit style={[{ position: "absolute" }, styles.text, textStyle]}
                                >
                                    {talkSlice.text}
                                </Text> : <></>}
                                <Text selectable={false} numberOfLines={numberOfLines || 3} adjustsFontSizeToFit style={[styles.text, textStyle,]}
                                >

                                    {talkSlice.text}
                                    {process.env.NODE_ENV === "development" && talkSlice.text && !isMobile() ? <Text style={[styles.text, textStyle, { position: "absolute", left: -135 }]}
                                        onPress={() => {
                                            const str = talkSlice.text;
                                            navigator.clipboard.writeText(str);
                                        }}>

                                        COPY

                                    </Text> : <></>}
                                </Text>

                            </View>
                        </>
                }

                <TTextInput></TTextInput>
            </KeyboardAvoidingView >
        </>

    );
};

export default TTalkContainer;
